import { useState } from "react";
import { IoLocation } from "react-icons/io5";
import Layout from '../components/layout';

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    subject: "",
    message: ""
  })

  const formChangeHandler = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const submitHandler = () => {

  }

  return (
    <Layout>
      <section className="lg:px-16 px-4 pb-6">
        <div className="max-w-7xl mx-auto py-4 mb-4 px-2">
          <h3 className="text-2xl font-semibold mb-4">Contact Us</h3>
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-1/2 bg-white border rounded-2xl p-6">
              <div className="mb-4">
                <div className="text-4xl text-red-600 mb-2" style={{color: "rgb(116, 83, 224)"}}><IoLocation /></div>
                <h4 className="text-xl font-bold">Ens Enterprises</h4>
                <p className="text-gray-700">
                  Fix Labs Private Limited, WeWork, Eldeco Center,<br />
                  New Delhi, 110017
                </p>
                <p className="text-gray-700 mt-2">
                  Email:{" "}
                  <a href="mailto:support@fixlabs.ai" className="text-blue-600 underline">
                    support@fixlabs.ai
                  </a>
                  <br />
                  Phone: +91 8860775669{" "}
                  <span className="text-gray-500 block">(Available 09:30 AM – 06:30 PM)</span>
                </p>
              </div>
            </div>

            <div className="w-full lg:w-1/2 bg-white border rounded-2xl p-6">
              <h3 className="text-xl font-bold mb-1">Get in Touch</h3>
              <p className="text-gray-600 mb-3">
                Have a question or comment? Use the form below to send us a message.
              </p>

              <div className="flex flex-col md:flex-row gap-3 mb-3">
                <input
                  type="text"
                  className="w-full md:w-1/2 border border-gray-300 rounded-lg p-2"
                  value={formData?.name}
                  name="name"
                  placeholder="Name"
                  onChange={formChangeHandler}
                  required
                />
                <input
                  type="email"
                  className="w-full md:w-1/2 border border-gray-300 rounded-lg p-2"
                  value={formData?.email}
                  name="email"
                  placeholder="Email"
                  onChange={formChangeHandler}
                  required
                />
              </div>

              <input
                type="tel"
                className="w-full border border-gray-300 rounded-lg p-2 mb-3"
                value={formData?.contact}
                name="contact"
                placeholder="Phone Number"
                onChange={formChangeHandler}
                required
              />

              <input
                type="text"
                className="w-full border border-gray-300 rounded-lg p-2 mb-3"
                value={formData?.subject}
                name="subject"
                placeholder="Subject"
                onChange={formChangeHandler}
                required
              />

              <textarea
                className="w-full border border-gray-300 rounded-lg p-2 mb-3"
                rows="4"
                value={formData?.message}
                name="message"
                placeholder="Message"
                onChange={formChangeHandler}
                required
              ></textarea>

              <button
                className="w-full text-white font-semibold py-2 rounded-lg transition"
                onClick={submitHandler}
                style={{ background: "rgb(116, 83, 224)" }}>
                {loading ? "Please wait..." : "SUBMIT"}
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Contact;
